import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDDisplayDateTimeStr } from '../Displayers/TEDDisplayDateTimeStr';
import { TEDParseDateTimeStr } from '../Parsers/TEDParseDateTimeStr';

class TEDFormatDateTimeStr implements IFormatter {
  displayer = TEDDisplayDateTimeStr.getInstance();
  parser = TEDParseDateTimeStr.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatDateTimeStr };
